export default {
    name: 'instamapsFooter',
};



// WEBPACK FOOTER //
// ./src/shared/components/footer/footer.js